import {CSSProperties, FC, ReactNode} from 'react'

interface ProcurementDocumentPreviewModalProps {
  visible: boolean
  onClose: () => void
  title: string
  subtitle?: ReactNode
  toolbar?: ReactNode
  children: ReactNode
  footer?: ReactNode
  printLabel?: string
  onPrint?: () => void
  downloadLabel?: string
  onDownload?: () => void
  bodyStyle?: CSSProperties
  bodyClassName?: string
  dialogClassName?: string
}

const ProcurementDocumentPreviewModal: FC<ProcurementDocumentPreviewModalProps> = ({
  visible,
  onClose,
  title,
  subtitle,
  toolbar,
  children,
  footer,
  printLabel = 'Print Format',
  onPrint,
  downloadLabel = 'Download PDF',
  onDownload,
  bodyStyle,
  bodyClassName = '',
  dialogClassName = '',
}) => {
  if (!visible) return null

  return (
    <div
      className='modal fade show d-flex align-items-center justify-content-center procurement-document-modal'
      tabIndex={-1}
      style={{
        backgroundColor: 'rgba(0,0,0,0.5)',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1050,
      }}
    >
      <div
        className={`modal-dialog modal-xl modal-dialog-centered procurement-view-modal-dialog ${dialogClassName}`}
        role='document'
      >
        <div className='modal-content procurement-document-modal-content bg-white'>
          <div className='modal-header border-bottom procurement-print-hide'>
            <div>
              <h3 className='modal-title fw-bold text-dark mb-1'>{title}</h3>
              {subtitle ? <p className='text-muted mb-0 fs-7'>{subtitle}</p> : null}
            </div>
            <button type='button' className='btn-close' onClick={onClose}></button>
          </div>

          <div className={`modal-body procurement-document-modal-body ${bodyClassName}`} style={bodyStyle}>
            {(toolbar || onPrint || onDownload) && (
              <div className='d-flex justify-content-between align-items-center mb-3'>
                <div>{toolbar}</div>
                <div className='d-flex align-items-center gap-2'>
                  {onDownload ? (
                    <button
                      type='button'
                      className='btn btn-sm btn-primary procurement-print-hide'
                      onClick={onDownload}
                    >
                      {downloadLabel}
                    </button>
                  ) : null}
                  {onPrint ? (
                    <button
                      type='button'
                      className='btn btn-sm btn-light procurement-print-hide'
                      onClick={onPrint}
                    >
                      {printLabel}
                    </button>
                  ) : null}
                </div>
              </div>
            )}
            {children}
          </div>

          <div className='modal-footer border-top procurement-print-hide'>
            {footer ?? (
              <button type='button' className='btn btn-light' onClick={onClose}>
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProcurementDocumentPreviewModal
